import React from 'react';
import {Header, Breadcrumb, Loader, Segment, Tab, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Icon} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import CrucigramaForm from "./CrucigramaForm";
import ManageCrucigramaPalabrasList from "../crucigramapalabras/ManageCrucigramaPalabrasList";
import ManageJuegos from '../juegos/ManageJuegos';



const ExamenPanel=({id, idObjeto, updateIdObjeto,
                   onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, color, form})=>{


     const panes = [
  {
    menuItem: 'Crucigrama',
    render: () => <Tab.Pane attached={false}>
       
         
         <CrucigramaForm 
                    strings={strings}
                    id={id}
                    onChange={onChange}
                    errors={errors}
                    datos={datos}
                    onSave={onSave}      
                    ajaxCallInProgress={ajaxCallInProgress}
                    color={color}
                    form={form}
                    permisos={permisos}
                />
         
         </Tab.Pane>
  },
  {
    menuItem: 'Palabras',
    render: () => 
          <div>
         {id?
                 <Tab.Pane attached={false}>
                  
                    <ManageCrucigramaPalabrasList
                    idForm={id}
                        />

     
             </Tab.Pane>
        :
          <Header as='h2' icon  textAlign='center'>
                <Icon name='info circle' />
                {strings?strings["configuracion"]:""}
                <Header.Subheader>
                    {strings?strings["altaBienRobado"]:""}
                </Header.Subheader>
            </Header>
         }
          </div>
  },
  {
    menuItem: 'Presentación',
    render: () => 
          <div>
         {id?
                 <Tab.Pane attached={false}>
                 <ManageJuegos
                    idForm={id}
                    
                />
     
                </Tab.Pane>
        :
          <Header as='h2' icon  textAlign='center'>
                <Icon name='info circle' />
                {strings?strings["configuracion"]:""}
                <Header.Subheader>
                    {strings?strings["altaBienRobado"]:""}
                </Header.Subheader>
            </Header>
         }
          </div>
  }
  
]
 
	return (
        <div >
        
            <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
                    <Loader size='big' inline content={strings?strings["Procesando"]:""}/>
            </Dimmer>

            <Header dividing>             
                <Header.Content>{strings?strings["Crucigrama"]:""}</Header.Content>
            </Header>

            <div>
            <Tab menu={{ pointing: true }} panes={panes} /> 
            </div>
         
        </div>
	);
};



export default ExamenPanel;